var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thai-hilo-history"},[_c('Tabs',{staticClass:"thai-hilo-history-tabs",attrs:{"type":"card","animated":false}},[_c('TabPane',{attrs:{"label":"RESULT"}},[_c('thai-hilo-result-history',{attrs:{"stat":_vm.stat,"historical-data":_vm.rsData,"game":_vm.game,"game-code":_vm.gameCode,"game-id":_vm.gameId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }